import { useRouter } from 'next/router'
import { APP_ROUTES, LOCATION_SEARCH_TYPE } from '../../types'
import {
  containsAllAirport,
  formatAllAirport
} from '../../utils/airport-helper'
import useSeti from '../CustomHooks/useSeti'

export default function useTypeAheadForDisplayName() {
  const { pathname, query } = useRouter()
  const {
    tab,
    'ambig-origin-city': ambigOriginCity,
    'ambig-dest-city': ambigDestCity
  } = query || {}
  const isFlightRoute = pathname === APP_ROUTES.flights || tab === 'flights'
  const haveCustomItemName = ambigOriginCity || ambigDestCity
  const showCityCode =
    useSeti('TYPEAHEAD_ALL_AIRPORTS_FIX', isFlightRoute) === 'DEFAULT'

  const itemDisplayNameTransform = (
    item: LOCATION_SEARCH_TYPE | Record<string, never> | null,
    skipFormat?: boolean
  ) => {
    if (item === null) {
      return
    }

    if (isFlightRoute && item.type === 'AIRPORT' && !skipFormat) {
      const displayNameSegments = [
        item.cityName,
        ...((item.countryCode === 'US' || item.countryCode === 'CA') &&
        item.stateCode
          ? [item.stateCode]
          : []),
        ...(item.countryCode !== 'US' ? [item.country] : [])
      ]

      const airportCode =
        !showCityCode && containsAllAirport(item) ? 'All Airports' : item.id

      return `${displayNameSegments.join(', ')} (${airportCode})`
    }
    return !showCityCode && containsAllAirport(item)
      ? formatAllAirport(item)
      : item.itemName
  }

  return isFlightRoute && !haveCustomItemName ? itemDisplayNameTransform : null
}
